import { Box, Typography } from "@mui/material";
import AppBarContainer from "../../components/shared/AppBarContainer";
import PageContentContainer from "../../components/shared/PageContentContainer";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useOutletContext, useNavigate, useLocation } from "react-router-dom";
import PasswordTextField from "../../components/shared/PasswordTextField";
import { LoadingButton } from "@mui/lab";
import CheckValidRow from "../../components/shared/CheckValidRow";
import {
  hasDigit,
  hasEnglishCharacter,
  hasLowercase,
  hasMoreThanEightChar,
  hasOneSpecialChar,
  hasRtlCharacter,
  hasUppercase,
  isPasswordValid,
} from "../../utils/validations";

function SetPasswordPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const mobile = location.state?.mobile || "";
  const [password, setPassword] = useOutletContext();

  const handleSubmit = () => {
    navigate("../confirm", { state: { mobile: mobile } });
  };

  return (
    <>
      <AppBarContainer
        centerElement={
          <Typography variant="h5" color={"common.white"}>
            ساخت حساب بلوط
          </Typography>
        }
      />
      <PageContentContainer sx={{ overflow: "auto" }}>
        <Box>
          <Typography variant="body2" color="grey.2">
            کلمه عبور
          </Typography>
          <PasswordTextField password={password} setPassword={setPassword} />
          <CheckValidRow
            sx={{ my: "2px", mt: 2 }}
            isValid={
              hasEnglishCharacter(password) && !hasRtlCharacter(password)
            }
            title="حروف انگلیسی"
          />
          <CheckValidRow
            sx={{ my: "2px" }}
            isValid={hasMoreThanEightChar(password)}
            title="حداقل ۸ کاراکتر"
          />
          <CheckValidRow
            sx={{ my: "2px" }}
            isValid={hasUppercase(password)}
            title="حداقل یک حرف بزرگ"
          />
          <CheckValidRow
            sx={{ my: "2px" }}
            isValid={hasLowercase(password)}
            title="حداقل یک حرف کوچک"
          />
          <CheckValidRow
            sx={{ my: "2px" }}
            isValid={hasDigit(password)}
            title="حداقل یک عدد"
          />
          <CheckValidRow
            sx={{ my: "2px" }}
            isValid={hasOneSpecialChar(password)}
            title="حداقل یک کاراکتر خاص (@,#,$ و ...)"
          />
        </Box>
        <Box
          sx={{
            flex: 1,
            width: "100%",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "flex-end",
            mt: 1,
          }}
        >
          <Box>
            <LoadingButton
              onClick={handleSubmit}
              disabled={!isPasswordValid(password)}
              variant="contained"
              color="primary"
              sx={{ height: 56, width: 48 }}
            >
              <ArrowBackIcon sx={{ color: "common.white", fontSize: 24 }} />
            </LoadingButton>
          </Box>
        </Box>
      </PageContentContainer>
    </>
  );
}

export default SetPasswordPage;
